export default __webpack_public_path__ + "static/overlay-video-68bbd97a04739b31bb8f6da70d8fa1c2.png";